<template>
  <div class="ChipDropdown">
    <v-menu v-model="showMenu" offset-y :disabled="disabled">
      <template v-slot:activator="{ on }">
        <v-btn
          class="white red--text text--darken-1 text-uppercase text--bold font-weight-bold dropdown__button"
          :class="[{ 'dropdown__button--disabled': disabled }, chipClass]"
          v-on="on"
          tabindex="0"
          rounded
        >
          <slot name="title">Dropdown Menu Title</slot>
          <v-icon
            v-if="!disabled"
            class="red--text text--darken-1 ml-1 mr-n2"
            :class="iconClass"
            >mdi-menu-down</v-icon
          >
        </v-btn>
      </template>
      <slot name="dropdown-content">
        <v-list dense>
          <v-subheader
            v-if="subHeader"
            class="dropdown__subheader font-weight-bold ml-2 black--text"
            >{{ subHeader }}</v-subheader
          >
          <v-list-item
            v-for="(item, index) in menuItems"
            :key="index"
            class="dropdown__list-item"
            :href="item.externalLink"
            :to="item.internalLink"
            :disabled="item.disabled"
            v-on="{click: itemClick(item)}"
            :class="{ selected: item.selected, disabled: item.disabled }"
          >
            {{ item.text }}
          </v-list-item>
        </v-list>
      </slot>
    </v-menu>
  </div>
</template>

<script>
/*menuItem Properties:
   - text - Text to be display for the menu item.
   - disabled - disables and provides styling to menu item to display as disabled.
   - selected - provides styling to the menu item to display as selected.
   - internalLink - binds 'to' on the menu item. Used for routing to a route in the app using vue-router.
   - externalLink - binds to 'href' on the menu item. Used for routing to an external page. Will convert item to an anchor tag.
   - onClick - binds to the 'click' event of the menu item. Used to call a function on click of the menu item.*/
export default {
  name: 'ChipDropdown',
  data() {
    return {
      showMenu: false
    }
  },
  props: {
    subHeader: {
      type: String
    },
    menuItems: {
      type: Array
    },
    chipClass: {},
    iconClass: {},
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    itemClick(item) {
      return event => {
        if (typeof item.onClick === 'function') {
          item.onClick(event)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-menu__content {
  margin-top: 8px; //Vuetify mt-2
}

.dropdown {
  &__subheader.v-subheader {
    cursor: default;
    font-size: 15px !important;
  }

  &__list-item {
    cursor: pointer;
    font-size: 15px;
    text-decoration: none;
    font-weight: inherit;

    &.selected {
      cursor: default;
    }

    &.selected,
    &:hover {
      background-color: $color-grey-6;
    }
  }

  &__button {
    padding: 0 10px !important;
    min-height: auto !important;
    height: 32px !important;
    box-shadow: none;
    font-size: 14px !important;

    &--disabled {
      pointer-events: none;
    }
  }
}

.mdi-menu-down {
  width: 24px;
}
</style>
